import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/login/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // ENDPOINT PUBBLICI: non toccare NIENTE (niente clone, niente withCredentials)
    if (this.isPublicUrl(req.url)) {
      return next.handle(req);
    }

    // ENDPOINT PROTETTI: aggiungi Authorization se presente
    const token = this.authService.getToken();
    const authReq = token
      ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : req;

    return next.handle(authReq.clone({ withCredentials: true }));
  }

  private isPublicUrl(url: string): boolean {
    const list = [
      '/v1/loginApp.do',
      '/v1/primoAccesso.do',
      '/v1/primaAutenticazione.do',
    ];
    try {
      const u = new URL(url, window.location.origin);
      return list.some(p => u.pathname.endsWith(p));
    } catch {
      return list.some(p => url.includes(p));
    }
  }
}
